import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { FastClick } from "../../../../core";
export var NoHitsErrorDisplay =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NoHitsErrorDisplay, _React$Component);

  function NoHitsErrorDisplay() {
    _classCallCheck(this, NoHitsErrorDisplay);

    return _possibleConstructorReturn(this, _getPrototypeOf(NoHitsErrorDisplay).apply(this, arguments));
  }

  _createClass(NoHitsErrorDisplay, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          errorLabel = _this$props.errorLabel,
          bemBlocks = _this$props.bemBlocks,
          resetSearchFn = _this$props.resetSearchFn,
          tryAgainLabel = _this$props.tryAgainLabel;
      return React.createElement("div", {
        "data-qa": "no-hits",
        className: bemBlocks.container()
      }, React.createElement("div", {
        className: bemBlocks.container("info")
      }, errorLabel), React.createElement("div", {
        className: bemBlocks.container("steps")
      }, React.createElement(FastClick, {
        handler: resetSearchFn
      }, React.createElement("div", {
        className: bemBlocks.container("step-action")
      }, tryAgainLabel))));
    }
  }]);

  return NoHitsErrorDisplay;
}(React.Component);